enum BroadLineOfBusiness {
	COMMERCIAL = 'COMM',
	PERSONAL = 'RES',
	NONE = 'none',
}

export default BroadLineOfBusiness;